import { render, staticRenderFns } from "./ProductsPanel.vue?vue&type=template&id=024563ca&scoped=true&"
import script from "./ProductsPanel.vue?vue&type=script&lang=ts&"
export * from "./ProductsPanel.vue?vue&type=script&lang=ts&"
import style0 from "./ProductsPanel.vue?vue&type=style&index=0&id=024563ca&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "024563ca",
  null
  
)

export default component.exports